import { isMobile } from '../../helpers/Helper';
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap';

type PaginationProps = {
    recordsCount: number
    rowsPerPage: number,
    rowName: any,
    currentPage?: any,
    setCurrentPage?: any,
    offsetStart: any,
    setOffsetStart: any
}

const Paginate = ({ recordsCount, rowName, offsetStart, rowsPerPage, setOffsetStart }: PaginationProps) => {

    const [currentPage, setCurrentPage] = useState<number>(1);

    const handlePaginatbuttonClick = (state: number, type: "prev" | "next" | "fullPrev" | "fullNext") => {
        if (type === "prev") {
            setOffsetStart(state - rowsPerPage);
            setCurrentPage(cur => cur - 1);
        }
        if (type === "next") {
            setOffsetStart(state + rowsPerPage);
            setCurrentPage(cur => cur + 1);
        }
        if (type === "fullPrev") {
            setOffsetStart(0);
            setCurrentPage(1);
        }
        if (type === "fullNext") {
            let totalPage = Math.ceil(recordsCount / rowsPerPage)
            setOffsetStart((totalPage - 1) * rowsPerPage);
            setCurrentPage(totalPage);
        }
    };

    const handleFullPrevButtonClick = () => {
        handlePaginatbuttonClick(offsetStart, "fullPrev");
    };

    const handleBackButtonClick = () => {
        handlePaginatbuttonClick(offsetStart, "prev");
    };

    const handleNextButtonClick = () => {
        handlePaginatbuttonClick(offsetStart, "next");
    };

    const handleFullNextButtonClick = () => {
        handlePaginatbuttonClick(offsetStart, "fullNext");
    };


    // const FindPageNumber = () => {
    //     let pageNumber = (offsetStart / rowsPerPage + 1) as number;
    //     setCurrentPage(offsetStart >= recordsCount ? 1 : pageNumber.toFixed(0));
    // }

    const nextDisabled = (offsetStart + rowsPerPage) >= recordsCount;
    const previosDisabled = offsetStart === 0;

    // useEffect(() => {
    //     FindPageNumber();
    // }, [])


    return (
        <React.Fragment>
            <Row className="">
                <Col xl={4} lg={4} md={4} sm={6} xs={6} className='d-flex justify-content-start'>
                    <div className="text-muted">{rowName} per page : <span className="fw-semibold text-dofy">{rowsPerPage}</span></div>
                </Col>
                {isMobile() && (
                    recordsCount <= rowsPerPage ? (
                        <Col xl={4} lg={4} md={4} sm={6} xs={6} className='d-flex justify-content-end align-items-center'>
                            <div>
                                <span className="fw-semibold text-dofy">{recordsCount}</span> {rowName}
                            </div>
                        </Col>) : (
                        <Col xl={4} lg={4} md={4} sm={6} xs={6} className='d-flex justify-content-end align-items-center'>
                            {(offsetStart + rowsPerPage) >= recordsCount ?
                                <div> <span className="fw-semibold text-dofy" >{offsetStart + 1}</span> - <span className="fw-semibold text-dofy">{recordsCount}</span> of <span className="fw-semibold text-dofy">{recordsCount}</span> {rowName}</div>
                                :
                                <div><span className="fw-semibold text-dofy" >{offsetStart + 1}</span> - <span className="fw-semibold text-dofy">{offsetStart + rowsPerPage}</span> of <span className="fw-semibold text-dofy">{recordsCount}</span> {rowName}</div>
                            }
                        </Col>))}
                {recordsCount > rowsPerPage && <Col xl={4} lg={4} md={4} sm={12} xs={12} className='justify-content-center d-flex align-items-center'>
                    <button onClick={handleFullPrevButtonClick} disabled={previosDisabled} className={`paginate-btn ${previosDisabled ? 'bg-light' : 'bg-primary bg-opacity-25'}`}>
                        <i className="fas fa-angle-double-left text-dofy"></i>
                    </button>
                    <button onClick={handleBackButtonClick} disabled={previosDisabled} className={`paginate-btn ${previosDisabled ? 'bg-light' : 'bg-primary bg-opacity-25'}`}>
                        <i className="mdi mdi-chevron-left text-dofy"></i>
                    </button>
                    <button className={`paginate-btn bg-light bg-opacity-10`}>
                        {(offsetStart + rowsPerPage) >= recordsCount ?
                            <p className='font-size-12 m-0'>{currentPage}</p>
                            :
                            <p className='font-size-12 m-0'>{currentPage}</p>
                        }
                    </button>

                    <button onClick={handleNextButtonClick} disabled={nextDisabled} className={`paginate-btn ${nextDisabled ? 'bg-light' : 'bg-primary bg-opacity-25'}`}>
                        <i className={`mdi mdi-chevron-right text-dofy`}></i>

                    </button>
                    <button onClick={handleFullNextButtonClick} disabled={nextDisabled} className={`paginate-btn ${nextDisabled ? 'bg-light' : 'bg-primary bg-opacity-25'}`}>
                        <i className={`fas fa-angle-double-right text-dofy`}></i>

                    </button>
                </Col>}
                {!isMobile() && (
                    recordsCount <= rowsPerPage ? (
                        <Col xl={8} lg={8} md={8} sm={12} xs={12} className='d-flex justify-content-end align-items-center'>
                            <div>
                                <span className="fw-semibold text-dofy">{recordsCount}</span> {rowName}
                            </div>
                        </Col>
                    ) : (
                        <Col xl={4} lg={4} md={4} sm={12} xs={12} className='d-flex justify-content-end align-items-center'>
                            {(offsetStart + rowsPerPage) >= recordsCount ?
                                <div> <span className="fw-semibold text-dofy" >{offsetStart + 1}</span> - <span className="fw-semibold text-dofy">{recordsCount}</span> of <span className="fw-semibold text-dofy">{recordsCount}</span> {rowName}</div>
                                :
                                <div><span className="fw-semibold text-dofy" >{offsetStart + 1}</span> - <span className="fw-semibold text-dofy">{offsetStart + rowsPerPage}</span> of <span className="fw-semibold text-dofy">{recordsCount}</span> {rowName}</div>
                            }
                        </Col>))}
            </Row>
        </React.Fragment>
    )
}

export default Paginate
